import Login from './Login'
import Home from './Home'
import LoginFailed from './LoginFailed'
import LoyaltyPresent from './LoyaltyPresent'
import BillingPlan from './BillingPlan'
import LoginAdmin from './LoginAdmin'
import InstallWizard from './InstallWizard'
import QrcodeBoot from './QrcodeBoot'
import GoogleCalendar from './GoogleCalendar'
import GoogleCalendarCmp from './GoogleCalendarCmp'
import BillingPlanByAccount from './BillingPlanByAccount'

export default {
  Login,
  Home,
  LoginFailed,
  LoyaltyPresent,
  BillingPlan,
  LoginAdmin,
  InstallWizard,
  QrcodeBoot,
  GoogleCalendar,
  BillingPlanByAccount,
  GoogleCalendarCmp
}



// WEBPACK FOOTER //
// ./src/components/Core/index.js